import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgNmrFid, SvgNmrFt, SvgNmr2D } from 'cheminfo-font';
import { memo } from 'react';
import ColorIndicator from './base/ColorIndicator';
import ShowHideMarkersButton from './base/ShowHideMarkersButton';
import ShowHideSpectrumButton from './base/ShowHideSpectrumButton';
const styles = {
    button: {
        backgroundColor: 'transparent',
        border: 'none',
        width: '26px',
        minWidth: '26px',
    },
    row: {
        display: 'flex',
        alignContent: 'center',
        height: '25px',
        borderBottom: '0.55px solid #f1f1f1',
    },
    name: {
        flex: 1,
        height: '100%',
        display: 'flex',
    },
    info: {
        flex: '1 1 1px',
        height: '100%',
        display: 'block',
        alignItems: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: '24px',
    },
    icon: {
        display: 'flex',
        margin: 'auto',
        justifyContent: 'center',
    },
};
function formatValueAsHTML(value) {
    if (value) {
        value = value.replace(/(?<value>\d+)/g, '<sub>$<value></sub>');
    }
    return value;
}
function SpectrumListItem({ activeSpectrum, markersVisible, data, onChangeVisibility, onChangeMarkersVisibility, onChangeActiveSpectrum, onOpenSettingModal, onContextMenu, }) {
    const activated = !activeSpectrum || activeSpectrum?.id === data.id;
    const { color, name, positiveColor, negativeColor } = data.display;
    return (_jsxs("div", { style: {
            ...styles.row,
            ...(activated
                ? { backgroundColor: '#fafafa' }
                : { opacity: activeSpectrum ? 0.2 : 1 }),
        }, onContextMenu: onContextMenu, children: [_jsx(ShowHideSpectrumButton, { data: data, onChangeVisibility: onChangeVisibility, style: styles.button }), _jsxs("div", { "data-test-id": "activate-deactivate-spectrum-button", style: styles.name, onClick: () => onChangeActiveSpectrum(data), children: [_jsx("div", { style: { ...styles.icon, width: '16px' }, children: data.info.isFid ? (_jsx(SvgNmrFid, {})) : data.info.dimension === 2 ? (_jsx(SvgNmr2D, {})) : (_jsx(SvgNmrFt, {})) }), _jsx("span", { style: styles.info, children: name }), _jsx("div", { style: styles.info, 
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: data.info && formatValueAsHTML(data.info.solvent),
                        } }), _jsxs("span", { style: styles.info, children: [_jsx("span", { style: {
                                    borderLeft: '0.55px solid #e5e5e5',
                                    paddingRight: '5px',
                                } }), data.info?.experiment] }), _jsx("span", { style: styles.info, children: data.info?.pulse })] }), _jsx(ShowHideMarkersButton, { data: data, style: {
                    ...styles.icon,
                    ...styles.button,
                }, onChangeMarkersVisibility: onChangeMarkersVisibility, markersVisible: markersVisible }), _jsx(ColorIndicator, { style: styles.button, dimension: data.info.dimension, color: { positiveColor, color, negativeColor }, activated: activated, onClick: (event) => onOpenSettingModal(data, event) })] }));
}
export default memo(SpectrumListItem);
